import { render } from "./DeleteCategory.vue?vue&type=template&id=5fca3d2e&scoped=true"
import script from "./DeleteCategory.vue?vue&type=script&lang=js"
export * from "./DeleteCategory.vue?vue&type=script&lang=js"

import "./DeleteCategory.vue?vue&type=style&index=0&id=5fca3d2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fca3d2e"]])

export default __exports__